import { MotivationUtil } from 'kuaidong-model';
import { RouteConfig } from 'vue-router';

export default [
  // 体育积分系统
  {
    path: '/tzy/motivation-point/mall',
    name: 'tzy_motivation_point_mall',
    component: () => import('../../views/tzy/motivationPoint/index.vue'),
    props: (_route) => ({ ..._route.query, ..._route.params }),
    meta: {
      title: '积分兑换',
    }
  },
  // 体育积分系统
  {
    path: '/tzy/motivation-point/mall/2025/spring',
    name: 'tzy_motivation_point_mall_2025_spring',
    redirect: { name: MotivationUtil.pointActivityCenterRouteName },
    // component: () => import('../../views/tzy/motivationPoint/Mall.vue'),
    // props: (_route) => ({ ..._route.query, ..._route.params }),
    // meta: {
    //   title: '积分兑换',
    // }
  },
  {
    path: '/tzy/motivation-point/scan',
    name: 'tzy_motivation_point_scan',
    component: () => import('../../views/tzy/motivationPoint/Scan.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '积分扫码',
    },
  },
  {
    path: '/tzy/motivation-point/records',
    name: 'tzy_motivation_point_records',
    component: () => import('../../views/tzy/motivationPoint/Records.vue'),
    props: (_route) => ({ ..._route.query, ..._route.params }),
    meta: {
      title: '积分明细',
    },
  },
  {
    path: '/tzy/motivation-point/rewards',
    name: 'tzy_motivation_point_rewards',
    component: () => import('../../views/tzy/motivationPoint/Rewards.vue'),
    props: (_route) => ({ ..._route.query, ..._route.params }),
    meta: {
      title: '我的奖品',
    },
  },

  // 用户设定广告禁止
  {
    path: '/tzy/ad-filter/index',
    name: 'tzy_ad_filter_index',
    component: () => import('../../views/tzy/adFilter/Index.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '广告设置',
    },
  },
  // 添加作业登记
  {
    path: '/wxpublic-stu/tzy/homework-regist/add',
    name: 'tzy_homework_regist_add',
    component: () => import('../../views/tzy/homeworkRegist/HomeworkRegistAdd.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '作业登记',
    },
  },
  // 作业登记
  {
    path: '/wxpublic-stu/tzy/homework-regist/week',
    name: 'tzy_homework_regist_week',
    component: () => import('../../views/tzy/homeworkRegist/HomeworkRegist.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '作业登记',
    },
  },
  // 课外作业单
  {
    path: '/wxpublic-stu/tzy/homework-sheet/week',
    name: 'tzy_homework_sheet_week',
    component: () => import('../../views/tzy/homeworkSheet/WeekSheet.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '课外作业单',
    },
  },

  // 课后一小时
  {
    path: '/tzy/one-hour-after-school/month',
    name: 'tzy_one_hour_after_school_month',
    component: () => import('../../views/tzy/oneHourAfterSchool/Month.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '校外锻炼一小时',
    },
  },
  {
    path: '/tzy/one-hour-after-school/rank',
    name: 'tzy_one_hour_after_school_rank',
    component: () => import('../../views/tzy/oneHourAfterSchool/Rank.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '校外锻炼一小时排行榜',
    },
  },
  {
    path: '/tzy/one-hour-after-school/rank-share',
    name: 'tzy_one_hour_after_school_rank_share',
    component: () => import('../../views/tzy/oneHourAfterSchool/RankShare.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '校外锻炼一小时排行榜',
    },
  },
  {
    path: '/tzy/one-hour-after-school/self-apply',
    name: 'tzy_one_hour_after_school_self_apply',
    component: () => import('../../views/tzy/oneHourAfterSchool/SelfApply.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '运动申报',
    },
  },
  {
    path: '/tzy/one-hour-after-school/self-apply-list',
    name: 'tzy_one_hour_after_school_self_apply_list',
    component: () => import('../../views/tzy/oneHourAfterSchool/SelfApplyList.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '运动申报记录',
    },
  },

  // 作业优秀学生，老师排行
  {
    path: '/tzy/homework-rank/best-students',
    name: 'tzy_homework_rank_best_students',
    component: () => import('../../views/tzy/homeworkRank/BestStudents.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '优秀学生',
    },
  },
  {
    path: '/tzy/homework-rank/best-students-share',
    name: 'tzy_homework_rank_best_students_share',
    component: () => import('../../views/tzy/homeworkRank/BestStudentsShare.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '优秀学生',
    },
  },
  {
    path: '/tzy/homework-rank/best-clazzs',
    name: 'tzy_homework_rank_best_clazzs',
    component: () => import('../../views/tzy/homeworkRank/BestClazzs.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '优秀班级',
    },
  },
  {
    path: '/tzy/homework-rank/best-clazzs-share',
    name: 'tzy_homework_rank_best_clazzs_share',
    component: () => import('../../views/tzy/homeworkRank/BestClazzsShare.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '优秀班级',
    },
  },
  // eslint-disable-next-line prettier/prettier
] satisfies RouteConfig[]
